<template>
  <el-dialog :title="title" class="MeterEditor" :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true" width="400px" @close="closeWin">
    <MeterTreeComponent width="380px" v-if="dialogVisible" height="50vh" :isCheckbox="isCheckbox" :project_id="project_id" ref="MeterTreeComponentRef" @onClick="onClickMeter" @onCheck="onCheckMeter" />
    <div v-if="isCheckbox" style="display: flex;flex-direction: row;justify-content: space-between;">
      <span>已选择：<span style="font-weight: bold;color: #ff3d00;">{{nodes.length}}</span> </span>  <el-button @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import MeterTreeComponent from "../../meter/components/MeterTreeComponent";
export default {
  name: "SelectMeterTree",
  components: {MeterTreeComponent},
  data(){
    return{
      title:"",
      dialogVisible:false,
      project_id:0,
      callback_func:null,
      isCheckbox:false,
      checked_keys:"",
      nodes:[]
    }
  },
  methods:{
    show({project_id=0,title="",isCheckbox=false,checked_keys=""},callback_func){
      const that=this;
      that.title=title;
      that.project_id=project_id;
      that.isCheckbox=isCheckbox;
      that.checked_keys=checked_keys;
      that.callback_func=callback_func
      that.$nextTick(function () {
        that.dialogVisible=true;
      })
    },
    onClickMeter(node){
      typeof this.callback_func==="function"&&this.callback_func(node)
    },
    onCheckMeter(nodes){
      this.nodes=nodes;
    },
    closeWin(){
      this.title="";
      this.project_id="";
      this.nodes=[];
      this.checked_keys="";
      this.callback_func=undefined;
      this.dialogVisible=false;
    },
    confirm(){
      typeof this.callback_func==="function"&&this.callback_func(this.nodes)
      this.dialogVisible=false;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/apportion_template/components/SelectMeterTree.vue